export default __webpack_public_path__ + "assets/images/f3470371ad064d261172714cd51bd866.svg";